import { render, staticRenderFns } from "./HomePreviewTouchLayer.vue?vue&type=template&id=353cd22e&scoped=true&"
import script from "./HomePreviewTouchLayer.vue?vue&type=script&lang=js&"
export * from "./HomePreviewTouchLayer.vue?vue&type=script&lang=js&"
import style0 from "./HomePreviewTouchLayer.vue?vue&type=style&index=0&id=353cd22e&prod&lang=scss&scoped=true&"
import style1 from "./HomePreviewTouchLayer.vue?vue&type=style&index=1&id=353cd22e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353cd22e",
  null
  
)

export default component.exports